import { GiftExchangeHistoryModel } from "src/types"
import ItemContent from "./ItemContent"

interface IGiftExchangeItemProps {
  data?: GiftExchangeHistoryModel
  isLastItem?: boolean
  onOpenRecieveGift: () => void
  onOpenGiftExchange: () => void
}

const GiftExchangeItem = ({
  data,
  onOpenGiftExchange,
  isLastItem = false,
  onOpenRecieveGift,
}: IGiftExchangeItemProps) => {
  return (
    <ItemContent
      key={`${data?.TransactionId || data?.Id}`}
      isLastItem={isLastItem}
      data={data}
      onOpenGiftChange={onOpenGiftExchange}
      onOpenGiftRecieve={onOpenRecieveGift}
    />
  )
}

export default GiftExchangeItem
